class AppleDevice {
    constructor () {
        this.initialize();
    }

    initialize () {
        // if not apple device
        this.hidePaymentIconApple();
    }

    hidePaymentIconApple () {
        const isApple = /(Mac|iPhone|iPod|iPad)/i;
        const $isSafari = document.querySelector('html').classList.contains('safari');
        const platform = navigator?.userAgentData?.platform || navigator?.platform; // https://erikmartinjordan.com/navigator-platform-deprecated-alternative
        const $iconPaymentApple = document.getElementsByClassName('is--applepay');

        if (isApple.test(platform) && $isSafari) {
            return false;
        } else {
            for (let i = 0; i < $iconPaymentApple.length; i++) {
                switch ($iconPaymentApple[i].nodeName) {
                case 'SPAN':
                    $iconPaymentApple[i].parentElement.classList.add('is--hidden');
                    break;
                case 'LI':
                    $iconPaymentApple[i].classList.add('is--hidden');
                    break;
                default:
                    console.log('No apple payment offered.');
                }
            }
        }
    }
}

export { AppleDevice };
